import { action } from "@ember/object"
import { inject as service } from "@ember/service"
import Component from "@glimmer/component"
import type { Course } from "@shared/models/course"
import type { Planbook } from "@shared/models/planbook"
import type { RotationCalendar } from "@shared/models/rotation-calendar"
import type EmberStore from "cc-frontend/services/ember-store"

interface Args {
  dateString: string
  courses: Array<Course>
  planbook: Planbook
  rotationCalendar: RotationCalendar
  focusedCourseId: string
  hiddenCourseIds: Array<string>
  editCourseTitleAndOrder: Function
  onCourseCreate: Function
}

export default class WholeDaySidebarComponent extends Component<Args> {
  @service("ember-store") declare store: EmberStore

  // Properties
  sortableChildren = []
  _scrolledToCourseId: string | null = null

  @action
  updateScroll(isInitial: boolean) {
    if (this.isDestroyed || this.isDestroying) return

    // Unified slots scroll themselves (useFocusedLessonScroll): they know when their content has
    // rendered and ride the reflow as their siblings mount, neither of which is visible from here.
    // This path measures `.js-lesson-exterior-wrapper`, which only legacy-lesson-editable renders.
    if (this.args.planbook.attributes.flags.unifiedLessons) return

    if (this.args.focusedCourseId !== this._scrolledToCourseId || isInitial) {
      const el: HTMLElement | null = document.querySelector(
        `.js-month-sidebar .js-lesson-exterior-wrapper[data-course-id="${this.args.focusedCourseId}"]`
      )
      const sidebar = document.querySelector(".js-month-sidebar")
      if (!el || !sidebar) return
      sidebar.scrollTo({ top: el.offsetTop - 80, behavior: isInitial ? "instant" : "smooth" })

      this._scrolledToCourseId = this.args.focusedCourseId
    }
  }

  @action
  onLessonLoad(_courseId: string) {
    // We re-scroll when any lesson loads, not just the focused one, in case it changes
    // the scroll position of the focused lesson.
    this.updateScroll(true)
  }

  @action
  addSortableChild(child) {
    //@ts-ignore
    this.sortableChildren.addObject(child)
  }

  @action
  removeSortableChild(child) {
    //@ts-ignore
    this.sortableChildren.removeObject(child)
  }
}
